import { render, staticRenderFns } from "./ContentCreatorView.vue?vue&type=template&id=5c674bea&scoped=true&"
import script from "./ContentCreatorView.vue?vue&type=script&lang=ts&"
export * from "./ContentCreatorView.vue?vue&type=script&lang=ts&"
import style0 from "./ContentCreatorView.vue?vue&type=style&index=0&id=5c674bea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c674bea",
  null
  
)

export default component.exports